import { render, staticRenderFns } from "./SolicitudD.vue?vue&type=template&id=4e98e33a&"
import script from "./SolicitudD.vue?vue&type=script&lang=js&"
export * from "./SolicitudD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports